module.exports = __webpack_public_path__ + "83f91e08bf9d90c036639207a5196ba2.png";